import {
  FC,
  Key,
  CSSProperties,
  ReactNode,
  useState,
  useEffect,
} from 'react';
// 组件
import { ProTooltip } from '../../antd';
import CopyText from '../../CopyText';
import RouteLink from '../../RouteLink';
// 方法
import { filterEmptyValue } from '../../utils/utils';
import { renderEnumName, renderEnumNames } from '../../utils/renderUtils';
// 常量
import { FormInstance } from 'antd/lib/form';
import { TABLE_COLUMN_EMPTY } from '../../constants/constant';
import { RouteLinkProps } from '../../RouteLink/interface';

export interface INameItem {
  name: string | number;
  options?: any[];
}
export interface SearchFormDisabledProps {
  /** 字段名 */
  name?: Key | Key[];
  /** 字段名数组 */
  names?: INameItem[];
  /** 是否为开关 */
  isSwitch?: boolean;
  /** 是否为日期 */
  isMoment?: boolean;
  /** 样式 */
  style?: CSSProperties;
  /** 枚举项 */
  options?: any[];
  /** 自定义输出内容 */
  render?: ReactNode | ((val?: any) => ReactNode);
  /** 分隔符 */
  splitSymbol?: string;
  /** form 控制实例 */
  form?: FormInstance;
  /** 日期格式 */
  format?: string;
  /** 单位 */
  company?: ReactNode;
  /** 是否在表格中展示 */
  isTable?: boolean;
  /** 是否可以复制 */
  copy?: boolean;
  /** 禁用文字链接配置 */
  routeLinkProps?: RouteLinkProps;
}

const SearchFormDisabled: FC<SearchFormDisabledProps> = props => {
  const {
    name,
    names,
    isSwitch,
    isMoment,
    style,
    options,
    render,
    splitSymbol,
    form,
    company,
    format,
    isTable,
    copy,
    routeLinkProps,
  } = props;
  const [flag, setFlag] = useState<number>(0);
  useEffect(() => {
    setTimeout(() => {
      setFlag(flag + 1);
    }, 200);
  }, []);
  const getFormItemName = () => {
    if (!form) return TABLE_COLUMN_EMPTY;
    if (Array.isArray(names)) {
      if (isMoment) {
        return names
          .map(v => {
            let optionName =
              form.getFieldValue(v.name)?.format?.(format) ||
              TABLE_COLUMN_EMPTY;
            return optionName;
          })
          .join(splitSymbol);
      }
      return names
        .map(v => {
          let optionName = filterEmptyValue(form.getFieldValue(v.name));
          if (v.options) optionName = renderEnumName(optionName, v.options);
          return optionName;
        })
        .join(splitSymbol);
    }
    if (!name) return TABLE_COLUMN_EMPTY;
    if (Array.isArray(name)) {
      return name
        .map(v => {
          let optionName = filterEmptyValue(form.getFieldValue(v));
          return optionName;
        })
        .join(splitSymbol);
    }
    const itemName = form.getFieldValue(name);
    if (options) {
      if (Array.isArray(itemName)) return renderEnumNames(itemName, options);
      return renderEnumName(itemName, options);
    }
    if (itemName === undefined || itemName === '' || itemName === null)
      return TABLE_COLUMN_EMPTY;
    if (isSwitch) return itemName ? '是' : '否';
    if (isMoment && typeof name === 'string') {
      if (Array.isArray(itemName)) {
        return itemName
          .map(v => v?.format?.(format) || TABLE_COLUMN_EMPTY)
          .join(splitSymbol);
      }
      return itemName.format?.(format) || TABLE_COLUMN_EMPTY;
    }
    if (Array.isArray(itemName)) return itemName.join('，');
    return itemName;
  };
  const renderChild = () => {
    const itemName = form?.getFieldValue(name || '');
    if (typeof render === 'function') return filterEmptyValue(render(itemName));
    return render;
  };
  const disableText = render !== undefined ? renderChild() : getFormItemName();
  const disableTextHTML = `${disableText}${company || ''}`;

  return (
    <>
      {isTable ? (
        <ProTooltip placement="topLeft" title={disableText}>
          <div className="yb-form-disabled yb-line-ellipsis" style={style}>
            {
              routeLinkProps ? (
                <RouteLink isCopy={copy} text={disableTextHTML} {...routeLinkProps} />
              ) : <>{disableText}{company || ''}</>
            }
            
          </div>
        </ProTooltip>
      ) : (
        <div className="yb-form-disabled text-line-feed" style={style}>
          {
            routeLinkProps ? <RouteLink isCopy={copy}  text={disableTextHTML} {...routeLinkProps} /> : (
              copy ? <CopyText text={disableTextHTML} /> : <>{disableText}{company || ''}</>
            )
          }
        </div>
      )}
    </>
  );
};

SearchFormDisabled.defaultProps = {
  isSwitch: false,
  splitSymbol: ' —— ',
};

export default SearchFormDisabled;
